export const QUESTION_SEPARATOR = '&!&' as const;
export const TRIGGER_ANSWER_SEPARATOR = '%!%' as const;

export const PREDEFINED_PROVIDED_ELSEWHERE = 'Provided Elsewhere' as const;
export const PREDEFINED_NOT_APPLICABLE = 'Not Applicable' as const;
export const PREDEFINED_MARKED_COMPLETED = 'Marked Completed' as const;
export const PREDEFINED_MARKED_NOT_NEEDED = 'Marked Not Needed' as const;
export const UNTRIGGERABLE_QUESTION_SNIPPET =
  '<p class="demo"><strong>Which of the following best suits your needs for your' as const;

export const SAVE_TOGGLE_DELAY_MS = 80 as const;
export const SAVE_TEXT_DELAY_MS = 4800 as const;

export const PREDEFINED_ANSWERS_LIST = [
  PREDEFINED_PROVIDED_ELSEWHERE,
  PREDEFINED_NOT_APPLICABLE,
  PREDEFINED_MARKED_COMPLETED,
  PREDEFINED_MARKED_NOT_NEEDED,
] as const;
